import script from "./LeaveAdminBulkView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveAdminBulkView.vue?vue&type=script&setup=true&lang=js"

import "./LeaveAdminBulkView.vue?vue&type=style&index=0&id=fd355a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd355a4c"]])

export default __exports__